export default __webpack_public_path__ + "static/logos-tiles-leclerc-7bab9244f5d3a399734238f33d730df0.svg";